import { Fab, Popper } from '@mui/material'
import { styled } from '@mui/system'
import Typography from '../../atoms/typography'

const shouldForwardProp = (prop) => !['show', 'position', 'top'].includes(prop)

export const Root = styled('div', { shouldForwardProp })`
	display: ${({ show }) => (show ? 'flex' : 'none')};
	flex-direction: column;
	position: fixed;
	top: ${({ top }) => top}%;
	transform: translateY(-50%);
	${({ position }) =>
		position === 'left'
			? `
					left: 0;
					align-items: flex-start;
			  `
			: position === 'right'
			? `
					right: 0;
					align-items: flex-end;
			  `
			: ''};

	z-index: 100;
`

export const FloatButton = styled('div', { shouldForwardProp })`
	position: fixed;
	z-index: 2;
	top: ${({ top }) => top}%;
	${({ position }) =>
		position === 'left'
			? `
					left: 16px;
					align-items: flex-start;
			  `
			: position === 'right'
			? `
					right: 16px;
					align-items: flex-end;
			  `
			: ''};
`

export const PopperStyled = styled(Popper)`
	z-index: 999;
`

export const PopperContent = styled('div')`
	background: ${({ theme }) => theme.palette.background.paper};
	border: 1px solid ${({ theme }) => theme.palette.primary.main};
	margin-bottom: ${({ theme }) => theme.spacing(2)};
	padding: ${({ theme }) => theme.spacing(3, 4)};
`

export const FabStyled = styled(Fab)``

export const Title = styled(Typography)``

export const Subtitle = styled(Typography)``

export const LinksWrapper = styled('div')`
	margin-bottom: ${({ theme }) => theme.spacing(2)};
	margin-top: ${({ theme }) => theme.spacing(2)};
	min-height: 100px;
`

export const Icons = styled('div')`
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	justify-items: flex-start;
	> div {
		width: 100%;
	}
	a {
		align-items: center;
		display: grid;
		gap: 10px;
		grid-auto-flow: column;
		justify-content: flex-start;
		margin-top: ${({ theme }) => theme.spacing(3)};
	}
`
